import Vue from "vue";

export const realtorsService = {
  list,
  getById,
  approve,
  reject,
  create,
  update,
  lock,
  getEventsById,
  getRealtorEventsById
};

function list(payload) {
  if (payload.realEstateId) {
    const params = {
      page: payload.page,
      items: payload.items,
      team_id: payload.team_id,
      status: payload.status
    };
    return Vue.axios.get(
      `v2/manager/state_agencies/${payload.realEstateId}/realtors`,
      { params }
    );
  } else {
    const params = { status: payload.status };
    return Vue.axios.get(`v1/realtors`, { params });
  }
}

function getById(payload) {
  if (payload.realEstateId) {
    return Vue.axios.get(
      `/v2/manager/state_agencies/${payload.realEstateId}/realtors/${payload.id}`
    );
  } else {
    return Vue.axios.get(`/v1/realtors/${payload.id}`);
  }
}

function approve(id) {
  return Vue.axios.post(`v1/realtors/${id}/approve`);
}

function reject(id) {
  return Vue.axios.post(`v1/realtors/${id}/reject`);
}

function lock(id) {
  return Vue.axios.post(`v1/realtors/${id}/block`);
}

function create(payload) {
  const formData = new FormData();

  formData.set("name", payload.name);
  formData.set("nickname", payload.nickname);
  formData.set("realtor_document_state_id", payload.document_state_id);
  formData.set("phone_number", payload.phone_number);
  formData.set("email", payload.email);
  formData.set("realtor_document_number", payload.realtor_document_number);

  if (payload.region_ids.length) {
    payload.region_ids.forEach(region_id => {
      formData.append("region_ids[]", region_id);
    });
  } else {
    formData.set("region_ids[]", []);
  }

  if (payload.logo) {
    formData.set("photo", payload.photo);
  }

  return Vue.axios.post(
    `v2/manager/state_agencies/${payload.realState}/realtors`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );
}

function getEventsById(payload) {
  const params = {
    start_date: payload.start_date,
    end_date: payload.end_date
  };

  return Vue.axios.get(`v1/realtors/${payload.realtorId}/events`, { params });
}

function getRealtorEventsById(payload) {
  const params = {
    page: payload.page,
    items: payload.items,
    start_date: payload.start_date,
    end_date: payload.end_date
  };

  return Vue.axios.get(`v2/admin/realtors/${payload.realtorId}/report`, {
    params
  });
}

function update(payload) {
  const formData = new FormData();

  formData.set("name", payload.name);
  formData.set("nickname", payload.nickname);
  formData.set("realtor_document_state_id", payload.document_state_id);
  formData.set("phone_number", payload.phone_number);
  formData.set("email", payload.email);
  formData.set("realtor_document_number", payload.realtor_document_number);
  formData.set("state_agency_id", payload.realState);

  if (payload.region_ids.length) {
    payload.region_ids.forEach(region_id => {
      formData.append("region_ids[]", region_id);
    });
  } else {
    formData.set("region_ids[]", []);
  }

  if (payload.logo) {
    formData.set("photo", payload.photo);
  }

  return Vue.axios.patch(`v1/realtors/${payload.id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}
